import { render, staticRenderFns } from "./TheFaq.vue?vue&type=template&id=aae47a7a&scoped=true&"
import script from "./TheFaq.vue?vue&type=script&lang=js&"
export * from "./TheFaq.vue?vue&type=script&lang=js&"
import style0 from "./TheFaq.vue?vue&type=style&index=0&id=aae47a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae47a7a",
  null
  
)

/* custom blocks */
import block0 from "./TheFaq.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports